<template>
  <!-- {{ currentZoom }}{{ currentCenter }} -->
  <div
    style="
      height: 100%;
      width: 100%;
      display: flex;
      border-radius: 30px;
      position: relative;
    "
  >
    <div @click="goto(item)" v-for="(item, i) in map" :key="i">
      <img
        :id="item.to"
        src="@/assets/images/betagro/gif/output-onlinegiftools (10).gif"
        style="position: absolute"
        :style="{
          width: '50px',
          height: '50px',
          cursor: 'pointer',
          top: item.top + '%',
          left: item.left + '%',
        }"
      />
      <b-tooltip :target="item.to" variant="info" triggers="hover">
        <h3>
          <b>Station {{ item.id }}</b>
        </h3>
      </b-tooltip>
    </div>

    <img
      style="width: 100%; height: 100%"
      src="@/assets/images/NikhomLatKrabang/S__58384570.jpg"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "Example",

  data() {
    return {
      map: [
        {
          id: 3,
          name: "SP3 ",
          status: 1,
          width: 6,
          height: 6,
          left: 54,
          top: 43,
          to: "Station03",
        },
        {
          id: 9,
          name: "SP2 ",
          status: 1,
          width: 6,
          height: 6,
          left: 9,
          top: 45,
          to: "Station09",
        },
        {
          id: 5,
          name: "SP1 ",
          status: 1,
          width: 6,
          height: 6,
          left: 14,
          top: 32,
          to: "Station05",
        },
        {
          id: 10,
          name: "JP ",
          status: 1,
          width: 6,
          height: 6,
          left: 18,
          top: 67,
          to: "Station10",
        },
        {
          id: 7,
          name: "EX1 ",
          status: 1,
          width: 6,
          height: 6,
          left: 86,
          top: 30,
          to: "Station07",
        },
        {
          id: 6,
          name: "EX2 ",
          status: 1,
          width: 6,
          height: 6,
          left: 27,
          top: 13,
          to: "Station06",
        },
      ],
    };
  },
  methods: {
    goto(item) {
      this.$router.push({
        path: "/" + item.to,
      });
    },
  },
};
</script>